/* eslint-disable react/no-unused-prop-types */
import React from 'react';

import { ClickAwayListener, MenuList, MenuItem } from '@mui/material';

import { IDeliveryNote } from 'commons/types';

const BulkActionBtnMenu: React.FC<{
  selectedDeliveryNotes: IDeliveryNote[];
  handleCloseMenu: () => void;
  handleOpenCancelConfirm: () => void;
}> = ({ handleCloseMenu, handleOpenCancelConfirm }) => (
  <ClickAwayListener onClickAway={handleCloseMenu}>
    <MenuList id="split-button-menu" autoFocusItem>
      <MenuItem
        onClick={() => {
          handleOpenCancelConfirm();
          handleCloseMenu();
        }}
        key="menu-item-cancel-delivery-note"
      >
        Cancel Delivery Note
      </MenuItem>
    </MenuList>
  </ClickAwayListener>
);

export default BulkActionBtnMenu;
